import { Component, Inject, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { UtilitiesService } from '../../../common/shared/services/utilities.service';
import { KeysPipe } from '../../../common/helper/pipes/keys.pipe';
import { NavigationService } from '../../../common/shared/services/navigation.service';
import { AuthService } from '../../../common/shared/services/auth.service';
import { DOCUMENT } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

  constructor(
    private _translateService: TranslateService,
    public _utilitiesService: UtilitiesService,
    private _authService: AuthService, @Inject(DOCUMENT) private document: Document, private _route: Router) { }

    public showLanguageDropdown = false;

  ngOnInit() {
  }

  changeLanguage(languageCode: string) {
    // the lang to use, if the lang isn't available, it will use the current loader to get them
    if (languageCode === 'se' || languageCode === 'en') {
      this.document.documentElement.lang = languageCode;
      this._translateService.use(languageCode);
    }

    this.toggleLanguageDropdown();
  }

  getCurrentLanguage() {
    return this._translateService.currentLang;
  }

  toggleLanguageDropdown() {
    this.showLanguageDropdown = !this.showLanguageDropdown;
  }

  logout() {
    this._authService.logout();
  }

  isLoggedIn() {
    return this._authService.isLoggedIn();
  }

  actionActive() {
    return this._utilitiesService.isSomeActionActive();
  }

  skipToMain(id: string) {
    this._route.navigate([], { fragment:id });
    document.getElementById('MainContent').focus()
  }
}
